import React, { Component } from "react";
import styled from "styled-components";
import * as Widget from "./Widget2";
import StepItem from "./StepItem";

const Data = [
  {
    img: "step01",
    title: "尋喜愛的口味",
    description: "追求屬於自己最獨一無二的喜好。"
  },
  {
    img: "step02",
    title: "化口味為品味",
    description: "咖啡的選擇是一種美學生活態度。"
  },
  {
    img: "step03",
    title: "化品味為生活",
    description: "咖啡是陪伴你思考和放鬆的最好夥伴。"
  }
];

class PartSection extends Component {
  render() {
    return (
      <Wrapper>
        <div className="title">好咖三部曲</div>
        <div className="steps">
          {Data.map((d, i) => (
            <StepItem
              key={i}
              data={d}
              number={i}
              row={true}
              css={`
                flex-direction: ${i % 2 === 1 ? "row-reverse" : "row"};
                box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.25);
                margin-bottom: 30px;
                & > .graphic {
                  margin-right: ${i % 2 === 1 ? "0" : "50"}px;
                  margin-left: ${i % 2 === 1 ? "50" : "0"}px;
                }
                @media screen and (max-width: 500px) {
                  flex-wrap: wrap;
                  padding: 25px 10px;
                  & > .graphic {
                    margin: 0px;
                  }
                }
              `}
            />
          ))}
        </div>
        {/* <div className="button">
          <Widget.OutlineButton
            onClick={() => 0}
            css="min-width: 295px; margin: 0 auto;"
          >
            開始找尋屬於你的品味
          </Widget.OutlineButton>
        </div> */}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  padding: 100px 10px;

  & > .title {
    margin-bottom: 42px;
    letter-spacing: 3.9px;
    font-weight: 500;
    font-size: 26px;
  }

  & > .steps {
    margin-bottom: 100px;
  }

  & > .button {
    display: flex;
    justify-content: center;
  }
`;

export default PartSection;
